export default {
    driverStatusLogCreateEdit_editTitle: "Actualizar tarjeta de tiempo del conductor",
    driverStatusLogCreateEdit_createTitle: "Nueva tarjeta de tiempo del conductor",
    driverStatusLogCreateEdit_action: "Acción",
    driverStatusLogCreateEdit_datetime: "Fecha y hora",
    driverStatusLogCreateEdit_success: "Exitoso",
    driverStatusLogCreateEdit_successMessage: "Tarjeta de tiempo guardada",
    driverStatusLogCreateEdit_invalidDriverStatus: `Acción del conductor no válida, valide el orden de las acciones, no se permiten acciones repetidas en línea, debe comenzar en "Marcar entrada" y terminar en "Marcar salida", no puede agregar acciones entre las acciones de "Pausa para comer"`,
    driverStatusLogCreateEdit_invalidDriverStatusDetail: "o por favor verifique y corrija los datos para el registro de: _DATE_",
};